import { render, staticRenderFns } from "./SlideToggle.vue?vue&type=template&id=12189764&scoped=true&lang=pug&"
import script from "./SlideToggle.vue?vue&type=script&lang=js&"
export * from "./SlideToggle.vue?vue&type=script&lang=js&"
import style0 from "./SlideToggle.vue?vue&type=style&index=0&id=12189764&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12189764",
  null
  
)

export default component.exports